// © Microsoft Corporation. All rights reserved.

/**
 * Enum for different app types
 * @enum
 */
export enum AppType {
    Edge = "edge",
    EdgeChromium = "edgeChromium",
    Finance = "finance",
    FirstParty = "firstParty",
    HomePage = "homePage",
    Hub = "hub",
    MicrosoftNews = "microsoftNews",
    MMX = "mmx",
    Office = "office",
    SuperApp = "superApp",
    Traffic = "traffic",
    Views = "views",
    Weather = "weather",
    Windows = "windows",
    WindowsShell = "windowsShell"
}